import { Fragment, FunctionComponent, h } from 'preact';
import classNames from 'classnames';
import { DeliveryWindowWithId } from '../../../stores/schedule/schedule-store';
import OrderExternalId from '../../../components/order-external-id/order-external-id';
import ScheduleSuccess from '../../../components/schedule-success/schedule-success';
import ScheduleDeliveryWindows from '../schedule-delivery-windows/schedule-delivery-windows';
import ContactNotifications from '../../../components/contact-notifications/contact-notifications';
import { ContactNotificationsOptions, OptInOutData } from '../../../types/shared-location.types';

interface Props {
	customerName: string;
	deliveryWindows: DeliveryWindowWithId[];
	selectedDeliveryWindow: DeliveryWindowWithId;
	onDeliveryWindowSelect: (deliveryWindow: DeliveryWindowWithId) => any;
	isScheduleButtonDisabled: boolean;
	externalId: string;
	isScheduled: boolean;
	onSchedule: () => void;
	enableContactNotificationEdit: boolean;
	onContactNotificationsChange: (contactNotifications: ContactNotificationsOptions) => void;
	onTermsChange: (approveTermsAndConditions: boolean) => void;
	optInOutData: OptInOutData;
	locale?: string;
	timezone?: string;
	showCalendar?: boolean;
	isMobile?: boolean;
}

const ScheduleContent: FunctionComponent<Props> = ({
	customerName,
	deliveryWindows,
	selectedDeliveryWindow,
	onDeliveryWindowSelect,
	isScheduleButtonDisabled,
	onSchedule,
	externalId,
	isScheduled,
	enableContactNotificationEdit,
	onContactNotificationsChange,
	onTermsChange,
	optInOutData,
	locale,
	timezone,
	showCalendar,
	isMobile
}) => {
	return (
		<div
			className={classNames('schedule-content', { 'calendar-view': showCalendar })}
			data-testid="schedule-content"
		>
			{!showCalendar && <OrderExternalId externalId={externalId} />}
			{!isScheduled && (
				<Fragment>
					<ScheduleDeliveryWindows
						customerName={customerName}
						deliveryWindows={deliveryWindows}
						onDeliveryWindowSelect={onDeliveryWindowSelect}
						onSchedule={onSchedule}
						isScheduleButtonDisabled={isScheduleButtonDisabled}
						locale={locale}
						timezone={timezone}
						showCalendar={showCalendar}
						isMobile={isMobile}
					/>
					{enableContactNotificationEdit && (
						<ContactNotifications
							onChange={onContactNotificationsChange}
							onTermsChange={onTermsChange}
							optInOutData={optInOutData}
						/>
					)}
				</Fragment>
			)}
			{isScheduled && <ScheduleSuccess deliveryWindow={selectedDeliveryWindow} />}
		</div>
	);
};

export default ScheduleContent;
